import React, { useState, useEffect } from 'react';
import { ModalWrapper, ButtonGroup } from 'components/molecules';
import { PopupProps } from 'react-popup-manager/dist/src';
import { Form, Button, Input, Select, message } from 'antd';
import { useSmsTemplate } from 'hooks';
import { fetcher } from 'services';
import { MSG } from 'commons/constants';

export interface MultiMailSmsModalProps extends PopupProps {
    ids: string;
    toStudents: string; 
}

const B2cMultiSmsSendModal = ({ isOpen, onClose, ids, toStudents }: MultiMailSmsModalProps): React.ReactElement => {
  /* ======================================================
   * states
   * ====================================================== */    
    const [tmpplateCode, setTmpplateCode] = useState<any[]>([]);
  /* ======================================================
  * hooks
  * ====================================================== */
    const { tmpplateList } = useSmsTemplate(0); 

   /* ======================================================
   * variables
   * ====================================================== */
  const [form] = Form.useForm();
  const {TextArea} = Input;
   /* ======================================================
   * events
   * ====================================================== */
    const onCancel = () => {
        onClose?.(false);
    };
        
    /* ======================================================
    * methods
    * ====================================================== */
 
    const onSubmit = (e) => {
        let msg: string = e.content;

        msg = msg.replaceAll("[$교육생이름]", "[$NAME]");
        msg = msg.replaceAll("[$직급]", "[$NOTE1]");
        msg = msg.replaceAll("[$과정명]", "[$NOTE2]");
        msg = msg.replaceAll("[$교육일시]", "[$NOTE3]");
        msg = msg.replaceAll("[$교육장소]", "[$NOTE4]");

        fetcher.b2c.postStudentMultiSmsSend ({
            ids: ids,
            subject: e.subject,
            content: msg,
        })
        .then((res) => {
            switch (res.code) {
                case 200:
                    message.info(MSG.SUCCESS_SMS_SEND, 1);
                    onClose?.(true);
                break;
                case 100:
                    alert(res.message);
                    onClose?.(true);
                break;                  
                default:  
                break;
            };
        });         
      };
  /* ======================================================
   * effects
   * ====================================================== */
    useEffect(() => {
        if (tmpplateList) {
            const newList = tmpplateList.map((item)=> {
                return {
                    value: item.id,
                    label: item.title,
                    subject: item.subject,
                    content: item.content
                }
            })    

            setTmpplateCode(newList);
        }
    }, [tmpplateList]);

    useEffect(() => {
        form.setFieldValue('send_to', toStudents);
    }, []);    
    

    return (
        <ModalWrapper open={isOpen} onCancel={onCancel} width={450} title={'문자 발송'} closable>
           <Form
                form={form}
                name="saleRate"
                layout="horizontal"  
                labelCol={{ flex: '125px' }}
                onFinish={onSubmit}
                style={{width:'100%'}}
                autoComplete="off"
            >
                <Form.Item label={'템플릿명'} rules={[{ required: true, message: '' }]}>
                    <Select 
                        options={tmpplateCode}
                        onSelect={(value, option )=>{
                            form.setFieldValue('subject', option.subject);
                            form.setFieldValue('content', option.content);
                        }}
                    />
                </Form.Item>  
                <Form.Item name="send_to" label={'받는사람'} rules={[{ required: true, message: '' }]}>
                    <Input.TextArea autoSize readOnly/>                    
                </Form.Item>                  
                <Form.Item name="subject" label={'제목'} rules={[{ required: true, message: '' }]}>
                    <Input type={'text'} placeholder='제목을 입력하세요' />
                </Form.Item>                                   
                <Form.Item name="content" label={'내용'} rules={[{ required: true, message: '' }]}>
                    <TextArea rows={15} placeholder='내용을 입력하세요'/>                    
                </Form.Item>                              
                <ButtonGroup className={'buttonsWrapper'}>
                    <Button onClick={onCancel}>취소</Button>
                    <Button htmlType="submit"  type="primary">{'발송'}</Button>
                </ButtonGroup>                
            </Form>
        </ModalWrapper>  
    )    
};

export default React.memo(B2cMultiSmsSendModal);    